import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button';

function FormBody(props) {
    const year = (new Date()).getFullYear();
    const years = Array.from(new Array(100),( val, index) => year - index);
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box mt={4} mb={4}>
                        <Typography variant="h6">The Continuing Legal Education Office of the Supreme Court of Ohio requires the following information in order to process your CLE credit.</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} error={props.errors.firstName} helperText={props.errors.firstName} value={props.formValues.firstName}  id="firstName" label="First Name" onChange={props.handleChange}/>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} error={props.errors.lastName} helperText={props.errors.lastName} value={props.formValues.lastName} id="lastName" label="Last Name" onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth={true} value={props.formValues.address1} id="address1" label="Address 1" onChange={props.handleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth={true} value={props.formValues.address2} id="address2" label="Address 2" onChange={props.handleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth={true} id="city" value={props.formValues.city} label="City" onChange={props.handleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                        <FormControl fullWidth={true}>
                            <InputLabel id="stateSelectLabel">State</InputLabel>
                            <Select
                                native
                                labelId="stateSelectLabel"
                                id="state"
                                value={props.formValues.state}
                                onChange={props.handleChange}
                                //value={age}
                                //onChange={handleChange}
                            >
                                <option value=""></option>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="DC">District Of Columbia</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">New York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dakota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dakota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </Select>
                        </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} value={props.formValues.zip} id="zip" label="Zip Code" onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} value={props.formValues.email} error={props.errors.email} helperText={props.errors.email} id="email" label="Email"  onChange={props.handleChange}/>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} value={props.formValues.phone} id="phone" label="Phone Number"  onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true}>
                        <InputLabel  id="gradYearLabel">Are you a CWRU Law alum? If so, please select year.</InputLabel>
                        <Select
                            native
                            value={props.formValues.classYear}
                            labelId="gradYearLabel"
                            id="classYear"
                            onChange={props.handleChange}
                        >
                            <option key="0" value=""></option>
                            {
                                years.map((year, index) => {
                                    return <option key={`year${index}`} value={year}>{year}</option>
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} value={props.formValues.activityCode1} error={props.errors.activityCode1} helperText={props.errors.activityCode1}  id="activityCode1" label="Activity Code 1"  onChange={props.handleChange}/>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth={true} value={props.formValues.activityCode2} error={props.errors.activityCode2} helperText={props.errors.activityCode2} id="activityCode2" label="Activity Code 2"  onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth={true} value={props.formValues.attorneyRegistration} error={props.errors.attorneyRegistration} helperText={props.errors.attorneyRegistration} id="attorneyRegistration" label="Attorney Registration Number"  onChange={props.handleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth={true} value={props.formValues.confirmAttorneyRegistration} error={props.errors.confirmAttorneyRegistration} helperText={props.errors.confirmAttorneyRegistration} id="confrimAttorneyRegistration" label="Confirm Attorney Registration Number"  onChange={props.handleConfirmAttorneyChange}/>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1">I agree that by typing my name below and clicking submit at the end of this form, I am agreeing to and electronically signing this document and that it will be binding on me to the same extent it would be if signed by me in person.</Typography>
                    <TextField fullWidth={true} error={props.errors.signature} value={props.formValues.signature} helperText={props.errors.signature}  id="signature" label="Signature" onChange={props.handleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2} >
                        <Typography variant="h4">Program Evaluation</Typography>
                        We are asking you to evaluate this program because you are in the best position to know its strengths and weaknesses. Your evaluation will help us to improve and design future programs. If you would like to speak with our program manager about this event, please call (216) 368-6619. 
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1"><strong>Unless otherwise noted, 5 = Excellent, 3 = Average, 1 = Poor</strong></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1">What is your overall evaluation of the program as to:</Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="programIncreaseKnowledgeLabel">Increasing your knowledge</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.programIncreaseKnowledge}
                                    labelId="programIncreaseKnowledgeLabel"
                                    id="programIncreaseKnowledge"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="programHoldInterestLabel">Holding your interest</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.programHoldInterest}
                                    labelId="programHoldInterestLabel"
                                    id="programHoldInterest"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="programConveyPracticalInfoLabel">Conveying practical information</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.programConveyPracticalInfo}
                                    labelId="programConveyPracticalInfoLabel"
                                    id="programConveyPracticalInfo"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField value={props.formValues.programComment} fullWidth={true} multiline={true} rows={5} id="programComment" label="Comments" onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2}>
                        <Typography variant="body1">What is your overall evaluation of the speaker(s):</Typography>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid item sm={8}>
                            <TextField value={props.formValues.speakerEvaluationNames} fullWidth={true} id="speakerEvaluationNames" label="Name(s)" onChange={props.handleChange}/>
                        </Grid>
                        <Grid item sm={4}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="speakerEvaluationLabel">Rating</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.speakerEvaluation}
                                    labelId="speakerEvaluationLabel"
                                    id="speakerEvaluation"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2}>
                        <Typography variant="body1">How well did the program meet your expectations as to:</Typography>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="specificSubjectsCoveredLabel">Specific subjects covered</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.specificSubjectsCovered}
                                    labelId="specificSubjectsCoveredLabel"
                                    id="specificSubjectsCovered"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="depthOfCoverageLabel">Depth of coverage</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.depthOfCoverage}
                                    labelId="depthOfCoverageLabel"
                                    id="depthOfCoverage"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="practicalRelevanceLabel">Practical relevance</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.practicalRelevance}
                                    labelId="practicalRelevanceLabel"
                                    id="practicalRelevance"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField value={props.formValues.moreValuable} fullWidth={true} multiline={true} rows={5} id="moreValuable" label="What one thing, if changed or added, would have made this seminar more valuable to you?" onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2}>
                        <Typography variant="body1">The following information about you will help us to evaluate and plan future programs:</Typography>
                    </Box>
                    <Grid  container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="practiceOrganizationLabel">Your current practice organization</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.practiceOrganization}
                                    labelId="practiceOrganizationLabel"
                                    id="practiceOrganization"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="Sole practitioner">Sole practitioner</option>
                                    <option value="Firm of 2 - 10 lawyers">Firm of 2 - 10 lawyers</option>
                                    <option value="Firm of 2 - 10 lawyers">Firm of 2 - 10 lawyers</option>
                                    <option value="Firm of 11 - 50 lawyers">Firm of 11 - 50 lawyers</option>
                                    <option value="Firm of over fifty lawyers">Firm of over fifty lawyers</option>
                                    <option value="In-house corporate counsel">In-house corporate counsel</option>
                                    <option value="Government agency">Government agency</option>
                                    <option value="Law faculty">Law faculty</option>
                                    <option value="Judiciary">Judiciary</option>
                                    <option value="Other">Other</option>
				
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="yearsInPracticeLabel">Your total years in practice</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.yearsInPractice}
                                    labelId="yearsInPracticeLabel"
                                    id="yearsInPractice"
                                    onChange={props.handleChange}
                                >
                                    <option value=""></option>
                                    <option value="less than two years">less than two years</option>
                                    <option value="2 - 5 years">2 - 5 years</option>
                                    <option value="6 - 10 years">6 - 10 years</option>
                                    <option value="11 - 25 years">11 - 25 years</option>
                                    <option value="over 25 years">over 25 years</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth={true} multiline={true} rows={5} id="therCLEPrograms" label="What other CLE programs would you attend if they were offered by Case Western Reserve University in the next 12 months (List topics)" onChange={props.handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel  id="heardAboutThisEventLabel">Would you please tell us how you heard about this event?</InputLabel>
                                <Select
                                    native
                                    value={props.formValues.heardAboutThisEvent}
                                    labelId="heardAboutThisEventLabel"
                                    id="heardAboutThisEvent"
                                    onChange={props.handleChange}
                                >
                                    
                                    <option value=""></option>
                                    <option value="Invitation">Invitation</option>
                                    <option value="E-mail announcement">E-mail announcement</option>
                                    <option value="Radio ad">Radio ad</option>
                                    <option value="Social media (Facebook, LinkedIn, Twitter, etc.)">Social media (Facebook, LinkedIn, Twitter, etc.)</option>
                                    <option value="Other">Other</option>
				
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField value={props.formValues.heardAboutThisEventOther} fullWidth={true} multiline={true} rows={5} id="heardAboutThisEventOther" label="If you selected Other above, please specify" onChange={props.handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button disabled={props.submitButtonDisabled} variant="contained" color="primary" onClick={props.submitForm}>
                        Submit For Credit
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default FormBody;
 